import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import MyPhoto from "../assets/images/1756909011020.jpeg";

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={MyPhoto} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/leandrocosta-git" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/leandro-rcosta" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
          <h1>Leandro Costa</h1>
          <p>Cybersecurity Analyst @ PwC</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/leandrocosta-git" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/leandro-rcosta" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;